module.exports = __webpack_public_path__ + "static/img/花瓶6.7167038.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶6.png
// module id = EAUs
// module chunks = 2